import {
    fetchApiHeaders,
    globalURL
} from "../../helpers/constants";


const getData = () => dispatch => {
    dispatch({
        type: "GET_CASES"
    })

    fetch(globalURL + "/case/getAll", {
        method: 'POST',
        headers: {
            ...fetchApiHeaders.POST
        }
    })
        .then((result) => result.json())
        .then(async (result) => {
            if (result.success) {
                dispatch({
                    type: "FETCH_CASES",
                    payload: result.data
                })
            } else {
                dispatch({
                    type: "ERROR_CASES",
                    payload: result
                })
            }
        })
        .catch((error) => {
            dispatch({
                type: "ERROR_CASES",
                payload: error
            });
        })
}


export {
    getData
}